import React from 'react';

import { NftCard, NftCardSectionVariant } from '@pkg/components';
import { type NftCollection, type NftCommon } from '@pkg/types/app/floorGame';

export interface CreditsProps {
    nftName: NftCommon['name'];
    collection: NftCollection;
    url?: string;
    compact?: boolean;
}

export function Credits({ nftName, collection, url, compact = false }: CreditsProps) {
    const collectionName = collection?.name;
    const collectionThumbnail = collection?.thumbnail;

    return (
        <NftCard.Section variant={NftCardSectionVariant.Credits}>
            <NftCard.Credits
                title={collectionName?.length ? collectionName : nftName}
                subtitle={collectionName?.length ? nftName : undefined}
                thumbnail={collectionThumbnail}
                url={url}
                compact={compact}
            />
        </NftCard.Section>
    );
}
